import { Link } from 'react-router-dom';
import { useEffect } from 'react';

function LangPage({ t }) {
  useEffect(() => {
    document.documentElement.lang = t.lang;
    document.title = `${t.title} — HD Video Download`;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', t.metaDesc);
  }, [t]);

  const dir = t.lang === 'ar' ? 'rtl' : 'ltr';

  return (
    <div className="app" dir={dir}>
      <div className="container">
        <h1 className="title">{t.title}</h1>
        <p className="hero-text">{t.heroText}</p>

        <div className="cta-section" style={{ marginTop: '0.5rem' }}>
          <Link to="/" className="cta-btn">{t.download} →</Link>
        </div>
      </div>

      <div className="seo-section">
        <h2>{t.seoTitle}</h2>
        <p>{t.seoDesc}</p>

        <div className="seo-features">
          <div className="seo-feature">
            <h3>{t.feature1Title}</h3>
            <p>{t.feature1Desc}</p>
          </div>
          <div className="seo-feature">
            <h3>{t.feature2Title}</h3>
            <p>{t.feature2Desc}</p>
          </div>
          <div className="seo-feature">
            <h3>{t.feature3Title}</h3>
            <p>{t.feature3Desc}</p>
          </div>
        </div>

        <div className="page-links">
          <Link to="/how-to-download" className="page-link">{t.howTo}</Link>
          <Link to="/faq" className="page-link">{t.faq}</Link>
        </div>
      </div>

      <footer className="footer">
        <div className="footer-links">
          <Link to="/">Home</Link>
          <Link to="/how-to-download">{t.howTo}</Link>
          <Link to="/faq">{t.faq}</Link>
        </div>
        <span>&copy; {new Date().getFullYear()} hdvideodownload.com — All rights reserved.</span>
        <a href="mailto:hdvideodownload44@gmail.com" className="footer-mail">hdvideodownload44@gmail.com</a>
      </footer>
    </div>
  );
}

export default LangPage;
